import React from "react";
import { BookOpenIcon, CheckCircle2Icon, GiftIcon, GlobeIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
import { MOCKUP_URL, offerAccess, offerBonuses, offerVolumes } from "../../data/offer";
type LineItem = {
  label: string;
  value: string;
};
function PriceList({
  title,
  items,
  icon
}: {
  title: string;
  items: LineItem[];
  icon: React.ReactNode;
}) {
  return <div data-id="element-240" data-mp="3f4ju044aiuvh">
      <p className="flex items-center gap-2 text-sm font-black uppercase tracking-wide text-brand" data-id="element-241" data-mp="3f4a38ebf8joq">
        {icon}
        {title}
      </p>
      <ul className="mt-3 divide-y divide-line" data-id="element-242" data-mp="3jwjmjbi16li1">
        {items.map(item => <li key={item.label} className="flex items-start justify-between gap-4 py-2.5" data-id="element-243" data-mp="3nvsgagd2mjdl">
            <span className="text-[15px] font-bold leading-snug text-ink" data-id="element-244" data-mp="3swpxoqq9b9e1">{item.label}</span>
            <span className="shrink-0 text-[15px] font-extrabold text-ink/50 line-through" data-id="element-245" data-mp="1p3zveq7y153">{item.value}</span>
          </li>)}
      </ul>
    </div>;
}
export function Offer() {
  return <section id="offer" className="bg-navy px-3 py-16 sm:px-4 sm:py-20" data-id="element-246" data-mp="1flvlk77x0063">
      <div className="mx-auto max-w-3xl" data-id="element-247" data-mp="1bks79p5imc6z">
        <div className="text-center" data-id="element-248" data-mp="1blthjrepiunn">
          <p className="inline-block rounded-full bg-coral px-4 py-1.5 text-sm font-black uppercase tracking-wide text-white" data-id="element-249" data-mp="1bmwae4vlb767">
            Special Introductory Offer
          </p>
          <h2 className="mt-4 text-balance text-[1.9rem] font-black leading-[1.12] text-white sm:text-4xl" data-id="element-250" data-mp="23bg8103a1fk4">
            Get the Complete Autism Communication Support Blueprint™ Collection
          </h2>
          <p className="mt-3 text-lg font-semibold text-white/80" data-id="element-251" data-mp="1ui328xk46jgm">
            Everything You Need to Organize Your Communication Support Resources in One Place.
          </p>
        </div>

        <div className="mt-8 rounded-3xl bg-white p-5 shadow-[0_20px_50px_rgba(0,0,0,0.25)] sm:p-8" data-id="element-252" data-mp="2n1i6gobiu3r3">
          <img src={MOCKUP_URL} alt="The complete Blueprint collection" className="mx-auto w-full max-w-lg" data-id="element-253" data-mp="2i7nr1x2y8axt" />
          <p className="mt-4 text-center text-lg font-black text-navy" data-id="element-254" data-mp="31690viquzjld">Here’s everything included in your collection:</p>

          <div className="mt-6 space-y-6" data-id="element-255" data-mp="366elwg2mi7uh">
            <PriceList title="Your six professional volumes" items={offerVolumes} icon={<BookOpenIcon className="h-4 w-4" aria-hidden="true" data-id="element-257" data-mp="2weikav1bvzli" />} data-id="element-256" data-mp="2sc45cm0s5jzi" />
            <PriceList title="Your five exclusive bonuses" items={offerBonuses} icon={<GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-259" data-mp="2idemapx5dtho" />} data-id="element-258" data-mp="2wce9dt50i0bq" />
          </div>

          <div className="mt-6 flex items-center justify-between rounded-2xl bg-brand-soft px-4 py-3" data-id="element-260" data-mp="2nf418gnhqrb1">
            <span className="text-sm font-black uppercase text-navy" data-id="element-261" data-mp="29fmfka5hru5w">Total suggested reference value</span>
            <span className="text-xl font-black text-coral line-through" data-id="element-262" data-mp="2dgeqd7u0i74a">$203</span>
          </div>

          <div className="mt-6 text-center" data-id="element-263" data-mp="7ng3ij0nkur6">
            <p className="text-sm font-black uppercase tracking-wide text-ink/70" data-id="element-264" data-mp="bojkx9ycmyui">Today’s special price</p>
            <p className="mt-1 text-[4.5rem] font-black leading-none text-cta sm:text-8xl" data-id="element-265" data-mp="1w6as02gvkuq3">
              $27<span className="ml-1 align-top text-2xl text-navy" data-id="element-266" data-mp="1s58txoyp2opp">USD</span>
            </p>
            <p className="mt-3 text-balance text-base font-black uppercase text-navy" data-id="element-267" data-mp="25wdl02nzy8of">
              One payment. Complete collection. No monthly subscription.
            </p>
          </div>

          <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-268" data-mp="213u9rccs7pms">
            {offerAccess.map(item => <li key={item} className="flex items-center gap-2.5" data-id="element-269" data-mp="2avgp9kw5kavc">
                <CheckCircle2Icon className="h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-270" data-mp="2av70u1qrabrr" />
                <span className="text-[15px] font-bold leading-snug text-ink" data-id="element-271" data-mp="2oupxnye4a0or">{item}</span>
              </li>)}
          </ul>

          <div className="mt-8" data-id="element-272" data-mp="uh8hwxjye84a">
            <CtaButton label="Yes! I want the complete Blueprint™ for $27" sub="Instant Digital Access · One-Time Payment · Lifetime Access to Purchased Materials" data-id="element-273" data-mp="ui9sl0x24slh" />
          </div>

          <div className="mt-7" data-id="element-274" data-mp="rw90z75sevx5">
            <Countdown label="Your promotional price ends in:" data-id="element-275" data-mp="vydtg2ki1mi7" />
          </div>

          <div className="mt-7" data-id="element-276" data-mp="w0gudhn6x01p">
            <ScarcityBar data-id="element-277" data-mp="10xqh2pj72xlu" />
          </div>

          <div className="mt-5 flex items-start gap-3 rounded-2xl bg-brand-soft p-4" data-id="element-278" data-mp="10y072d48p4rj">
            <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-279" data-mp="15vieu06itdxy" />
            <p className="text-sm font-bold leading-relaxed text-navy" data-id="element-280" data-mp="89uljo5d3bqn">
              Automatic currency conversion: your checkout will automatically display the price in your local
              currency and the final purchase amount.
            </p>
          </div>

          <p className="mt-4 text-center text-xs font-semibold text-ink/55" data-id="element-281" data-mp="mxfn3dml92wg">
            Suggested reference values are illustrative offer comparisons and are not independently verified retail
            prices.
          </p>
        </div>

        <div className="mt-12 text-center" data-id="element-282" data-mp="3qlhms9nkfn0k">
          <p className="text-balance text-2xl font-black uppercase leading-tight text-white sm:text-3xl" data-id="element-283" data-mp="3qkg2deknto66">
            Don’t miss the current introductory offer
          </p>
          <div className="mt-6" data-id="element-284" data-mp="3e4yema5s60b0">
            <Countdown tone="dark" label="Your promotional price ends in:" data-id="element-285" data-mp="3953s0it1fwvr" />
          </div>
          <p className="mt-7 text-xl font-black uppercase text-sun" data-id="element-286" data-mp="3460v5ln7owyv">Get the complete collection for just $27</p>
          <div className="mt-5" data-id="element-287" data-mp="3045k3pfhb57w">
            <CtaButton tone="dark" label="Get instant access now" sub="Secure Checkout · One-Time Payment" data-id="element-288" data-mp="305guw97cdd8i" />
          </div>
        </div>
      </div>
    </section>;
}